import { Suspense, useMemo, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Popper from 'components/global/Popper';
import Tabs from 'components/global/Tabs';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';
import PATHS, { mergePaths } from 'utils/paths';

import { faCog, faDownload } from '@fortawesome/pro-solid-svg-icons';

import DownloadConfig from './DownloadConfig';

const OTOFlex = () => {
	const [buttonRef, setButtonRef] = useState(null);
	const navigate = useNavigate();

	const tabs = useMemo(
		() => [
			{
				label: 'unassignedOrders',
				path: mergePaths(PATHS.OTO_FLEX_MAIN, PATHS.UNASSIGNED_ORDERS)
			},
			{
				label: 'processingOrders',
				path: mergePaths(PATHS.OTO_FLEX_MAIN, PATHS.PROCESSING_ORDERS_SUB)
			},
			{
				label: 'historyOrders',
				path: mergePaths(PATHS.OTO_FLEX_MAIN, PATHS.HISTORY_ORDERS_SUB)
			}
		],
		[]
	);
	const isMobile = useMediaQuery(Breakpoints.mobileLandscape);

	return (
		<div>
			<PageHeader
				title="otoFlex-orders"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/oto-flex-order.json.gz"
				moduleName="oto-flex">
				<Button
					icon={faCog}
					variant="outline"
					label="editSettings"
					onClick={() => {
						navigate(PATHS.OTOFLEX_SETTINGS, {
							state: { otoModule: false, showBackButton: true }
						});
					}}
				/>
				<Button
					ref={setButtonRef}
					icon={faDownload}
					size="small"
					variant="outline"
					label={isMobile ? 'downloadAppMobile' : 'downloadApp'}
				/>
				{buttonRef && (
					<Popper
						wrapperId="downloadPopper"
						refElement={buttonRef}
						placement="bottom-end"
						offsetX={0}
						offsetY={1}
						hoverMode>
						{(closePopper) => <DownloadConfig closePopper={closePopper} />}
					</Popper>
				)}
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default OTOFlex;
